// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SoDecJZJekD9VXGoBRAv:hover, .SoDecJZJekD9VXGoBRAv[data-hovered] {
    font-weight: 500;
    background-color: #1A1B1E;
}

.rPZZLCjsjLz1jbmG24Ac:hover, .HUkwQ3eUCSKsxB3dGtu9[data-hovered] {
    font-weight: 500;
    background-color: #FFF;
}

.wkptMKovF3DMMPcSLksQ:hover { opacity: 0.7 }

.bppvzWg1MyGcDqexjWBn:hover { border-color:#1C7ED6 !important; }


.BPpNYG3BBPhMoH_kEKNn:hover {
    border: 1px solid #ced4da;
}

.uNd_P_xBfp3Hi9UeTpeL:hover { font-weight: 700; }


.alsXWypGk7Ae2WTv858X option { font-size: 18px }

.RcAQV6LOJGDWLP0YUS2M {
    text-decoration: none;
}

.RcAQV6LOJGDWLP0YUS2M:hover {
    text-decoration: underline;
    cursor: pointer;
}

.yDiAPFplaQm8y2M_5FCe svg {
    width: 50px !important;
    height: 50px !important;
}

.zSMn5DdldextAhXW_hLv {}

.KmH51Y5MC2WaFtDRtQMG:hover {
    background-color: #dee2e6 !important;
    cursor: pointer;
}

.KmH51Y5MC2WaFtDRtQMG:active {
    background-color: #c8cbcf !important;
}

.yrNiplQyCfFxlu4vlczm:hover {
    background-color: #e9e9e9 !important;
    cursor: pointer;
    outline: solid 2px dodgerblue;
}

.yrNiplQyCfFxlu4vlczm:active {
    background-color: #e0e0e0 !important;
}

.zSMn5DdldextAhXW_hLv .qNc4NfFSyuX7ta1JyBB_ { display: flex; }
.zSMn5DdldextAhXW_hLv:hover .qNc4NfFSyuX7ta1JyBB_ { display: none; }

.zSMn5DdldextAhXW_hLv .O6Zf2Ow90NyjSn_qeqx0 { display: none; }
.zSMn5DdldextAhXW_hLv:hover .O6Zf2Ow90NyjSn_qeqx0 { display: flex; }

.zT1NOl7KhBasj0r7od2W {
}

.zT1NOl7KhBasj0r7od2W .N0KbkwCUcryXpM11AuAS { display: none; }
.zT1NOl7KhBasj0r7od2W:hover .N0KbkwCUcryXpM11AuAS { display: flex; }

.Q5DliQI8BTG_rkF66nzT {
    max-width: 250px;
    width: 250px;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    border-left: none;
    border-top: none;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;
    background-color: rgb(245, 245, 245);
    position: sticky;
    top: 0;
    overflow: hidden;
}

.GfS3NWY3PKAkBjdEnVDs, .Hii_FjAti_hqylSBWMEe {
    height: 37px;
    max-width: 250px;
    width: 250px;
    box-sizing: border-box;
    border: 1px solid #dee2e6;
    border-left: none;
    border-top: none;
    align-items: center;
    justify-content: space-between;
    background-color: #FFF;
    overflow: hidden;
    position: relative;
}

.zJ49isdNlYmChBzEMIhU {
    background-color: #f5f5f5;
}

.Hii_FjAti_hqylSBWMEe {
    left: 0;
    position: sticky;
    z-index: 1000;
}

.jIyW96HZskCRTI5ywi2g {
    flex: 1;
    height: 100%;
}

.jIyW96HZskCRTI5ywi2g input {
    background-color: unset;
    color: #000;
    opacity: 1;
}

.jIyW96HZskCRTI5ywi2g button {
    background-color: unset;
    color: #000;
    opacity: 1;
}

.LpaPfGiDaCy68OydqMYp {
    align-items: center;
    justify-content: space-between;
    padding: 8;
    overflow: hidden;
    z-index: 999
}


.mRtwTR7uMDPLAWuqIiY_ {
    transform: translateY(-100%); /* Hide the header */
}

.qDlDxcFelaN2ieWMzAkH {
    transform: translateY(0); /* Show the header */
}


.hxppBNLCLL_xlfEc7JPN {
    animation: XUzjBVt87ThF3ML3fJG_ 2s infinite;
}

@keyframes XUzjBVt87ThF3ML3fJG_ {
    50% {
        border-color: red;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/nestedStyles.module.css"],"names":[],"mappings":";AACA;IACI,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA,8BAA+B,aAAa;;AAE5C,8BAA2B,+BAA+B,EAAE;;;AAG5D;IACI,yBAAyB;AAC7B;;AAEA,8BAAyB,gBAAgB,EAAE;;;AAG3C,+BAAuB,gBAAgB;;AAEvC;IACI,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA,uBAAe;;AAEf;IACI,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,8CAA4B,aAAa,EAAE;AAC3C,oDAAkC,aAAa,EAAE;;AAEjD,8CAA4B,aAAa,EAAE;AAC3C,oDAAkC,aAAa,EAAE;;AAEjD;AACA;;AAEA,8CAAiC,aAAa,EAAE;AAChD,oDAAuC,aAAa,EAAE;;AAEtD;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,oCAAoC;IACpC,gBAAgB;IAChB,MAAM;IACN,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,UAAU;IACV,gBAAgB;IAChB;AACJ;;;AAGA;IACI,4BAA4B,EAAE,oBAAoB;AACtD;;AAEA;IACI,wBAAwB,EAAE,oBAAoB;AAClD;;;AAGA;IACI,2CAA4B;AAChC;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":["\n.hover-button-dark-mode:hover, .hover-button-dark-mode[data-hovered] {\n    font-weight: 500;\n    background-color: #1A1B1E;\n}\n\n.hover-button-dark-light:hover, .hover-button-light-mode[data-hovered] {\n    font-weight: 500;\n    background-color: #FFF;\n}\n\n.hover-clickable-image:hover { opacity: 0.7 }\n\n.hover-action-blue:hover { border-color:#1C7ED6 !important; }\n\n\n.hover-text-ListItem:hover {\n    border: 1px solid #ced4da;\n}\n\n.hover-text-bold:hover { font-weight: 700; }\n\n\n.selectNative option { font-size: 18px }\n\n.hover-text-action {\n    text-decoration: none;\n}\n\n.hover-text-action:hover {\n    text-decoration: underline;\n    cursor: pointer;\n}\n\n.mantine-Carousel-control-large svg {\n    width: 50px !important;\n    height: 50px !important;\n}\n\n.hover-button {}\n\n.hover-action-card:hover {\n    background-color: #dee2e6 !important;\n    cursor: pointer;\n}\n\n.hover-action-card:active {\n    background-color: #c8cbcf !important;\n}\n\n.hover-action-card-outlined:hover {\n    background-color: #e9e9e9 !important;\n    cursor: pointer;\n    outline: solid 2px dodgerblue;\n}\n\n.hover-action-card-outlined:active {\n    background-color: #e0e0e0 !important;\n}\n\n.hover-button .hover-hide { display: flex; }\n.hover-button:hover .hover-hide { display: none; }\n\n.hover-button .hover-show { display: none; }\n.hover-button:hover .hover-show { display: flex; }\n\n.hover-image {\n}\n\n.hover-image .hover-image-show { display: none; }\n.hover-image:hover .hover-image-show { display: flex; }\n\n.bulk-edit-header {\n    max-width: 250px;\n    width: 250px;\n    box-sizing: border-box;\n    border: 1px solid #dee2e6;\n    border-left: none;\n    border-top: none;\n    align-items: center;\n    justify-content: space-between;\n    padding: 5px 10px;\n    background-color: rgb(245, 245, 245);\n    position: sticky;\n    top: 0;\n    overflow: hidden;\n}\n\n.bulk-edit-column, .bulk-edit-column-sticky {\n    height: 37px;\n    max-width: 250px;\n    width: 250px;\n    box-sizing: border-box;\n    border: 1px solid #dee2e6;\n    border-left: none;\n    border-top: none;\n    align-items: center;\n    justify-content: space-between;\n    background-color: #FFF;\n    overflow: hidden;\n    position: relative;\n}\n\n.bulk-edit-column-disabled {\n    background-color: #f5f5f5;\n}\n\n.bulk-edit-column-sticky {\n    left: 0;\n    position: sticky;\n    z-index: 1000;\n}\n\n.bulk-edit-column-input {\n    flex: 1;\n    height: 100%;\n}\n\n.bulk-edit-column-input input {\n    background-color: unset;\n    color: #000;\n    opacity: 1;\n}\n\n.bulk-edit-column-input button {\n    background-color: unset;\n    color: #000;\n    opacity: 1;\n}\n\n.bulk-edit-column-text {\n    align-items: center;\n    justify-content: space-between;\n    padding: 8;\n    overflow: hidden;\n    z-index: 999\n}\n\n\n.transform-hidden {\n    transform: translateY(-100%); /* Hide the header */\n}\n\n.transform-visible {\n    transform: translateY(0); /* Show the header */\n}\n\n\n.pulse-red-border {\n    animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n    50% {\n        border-color: red;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"hover-button-dark-mode": `SoDecJZJekD9VXGoBRAv`,
	"hover-button-dark-light": `rPZZLCjsjLz1jbmG24Ac`,
	"hover-button-light-mode": `HUkwQ3eUCSKsxB3dGtu9`,
	"hover-clickable-image": `wkptMKovF3DMMPcSLksQ`,
	"hover-action-blue": `bppvzWg1MyGcDqexjWBn`,
	"hover-text-ListItem": `BPpNYG3BBPhMoH_kEKNn`,
	"hover-text-bold": `uNd_P_xBfp3Hi9UeTpeL`,
	"selectNative": `alsXWypGk7Ae2WTv858X`,
	"hover-text-action": `RcAQV6LOJGDWLP0YUS2M`,
	"mantine-Carousel-control-large": `yDiAPFplaQm8y2M_5FCe`,
	"hover-button": `zSMn5DdldextAhXW_hLv`,
	"hover-action-card": `KmH51Y5MC2WaFtDRtQMG`,
	"hover-action-card-outlined": `yrNiplQyCfFxlu4vlczm`,
	"hover-hide": `qNc4NfFSyuX7ta1JyBB_`,
	"hover-show": `O6Zf2Ow90NyjSn_qeqx0`,
	"hover-image": `zT1NOl7KhBasj0r7od2W`,
	"hover-image-show": `N0KbkwCUcryXpM11AuAS`,
	"bulk-edit-header": `Q5DliQI8BTG_rkF66nzT`,
	"bulk-edit-column": `GfS3NWY3PKAkBjdEnVDs`,
	"bulk-edit-column-sticky": `Hii_FjAti_hqylSBWMEe`,
	"bulk-edit-column-disabled": `zJ49isdNlYmChBzEMIhU`,
	"bulk-edit-column-input": `jIyW96HZskCRTI5ywi2g`,
	"bulk-edit-column-text": `LpaPfGiDaCy68OydqMYp`,
	"transform-hidden": `mRtwTR7uMDPLAWuqIiY_`,
	"transform-visible": `qDlDxcFelaN2ieWMzAkH`,
	"pulse-red-border": `hxppBNLCLL_xlfEc7JPN`,
	"pulse": `XUzjBVt87ThF3ML3fJG_`
};
export default ___CSS_LOADER_EXPORT___;
